import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Encriptar } from "../Util/Encripcion";
import loadingGif from "../loading.gif";
import swal from "sweetalert";
import apiClient from "../RedProveedores/apiClient";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { es } from "date-fns/locale";
import axiosSomit from "../axios-config";
import {
  SearchSlash,
  Stethoscope,
  CalendarClock,
  Phone,
  Star,
  Send,
  MessageSquare,
  ArrowLeft,
  Ambulance,
  User,
  Clock,
  Calendar,
  CalendarHeart,
} from "lucide-react";
import { Input, Label, Button, InputGroupText } from "reactstrap";
import { Modal, Form, Col, Row, InputGroup, Card } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
const RedProvFormularioModal = ({ show, onClose }) => {
  const [medico, setMedico] = useState("");
  const [nombrePaciente, setNombrePaciente] = useState("");
  const [fecha, setFecha] = useState();
  const [hora, setHora] = useState();
  const [telefono, setTelefono] = useState("");
  const [especialidad, setEspecialidad] = useState("");
  const [especialidades, setEspecialidades] = useState([]);
  const [comentario, setComentario] = useState("");
  const [loading, setLoading] = useState(false);
  const handleEnviar = async () => {
    //console.log({ medico,especialidad, fechaHora, telefono });

    if (
      !medico ||
      !especialidad ||
      !fecha ||
      !hora ||
      !telefono ||
      !nombrePaciente
    ) {
      swal(
        "Formulario incompleto",
        "Por favor, complete todos los datos solicitados antes de enviar.",
        "info"
      );
      return;
    }
    setLoading(true);
    /*const fechaFormateada = fecha.toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });*/

    const yyyy = fecha.getFullYear();
    const mm = String(fecha.getMonth() + 1).padStart(2, "0"); // +1 porque enero es 0
    const dd = String(fecha.getDate()).padStart(2, "0");

    const fechaFormateada = `${yyyy}-${mm}-${dd}`;

    const horaFormateada = hora.toLocaleTimeString("es-ES", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    const pFechaHora = `${fechaFormateada}T${horaFormateada}`;
    let datos = {
      pMedico: medico,
      pEspecialidad: especialidad.name,
      pFechaHora: pFechaHora,
      pTelefono: telefono,
      pNombrePaciente: nombrePaciente,
    };
    let datosEncriptados = Encriptar(JSON.stringify(datos));
    apiClient
      .post(
        `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/nuevaCita`,
        datosEncriptados
      )
      .then((respuesta) => {
        //console.log(respuesta);
        if (respuesta.status === 200) {
          swal(
            "Formulario",
            "El formulario fue enviado correctamente.",
            "success"
          );
          setMedico("");
          setEspecialidad(null);
          setFecha(null);
          setHora(null);
          setNombrePaciente("");
          setTelefono("");
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const handleRegresar = () => {
    onClose();
  };

  const SectionDivider = ({
    mensaje = "Datos del Paciente",
    icon: Icon = User,
  }) => {
    return (
      <div className="d-flex align-items-center my-4">
        <div className="flex-grow-1 border-top"></div>
        <div
          className="px-3 fw-bold d-flex align-items-center"
          style={{ color: "rgb(0, 52, 121)" }}
        >
          <Icon size={18} className="me-2" />
          {mensaje}
        </div>
        <div className="flex-grow-1 border-top"></div>
      </div>
    );
  };

  useEffect(() => {
    axiosSomit
      .get(`${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/specialities?aseguradora=${sessionStorage.getItem("codigoAseguradora")}`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
        },
      }
      )
      .then((respuesta) => {
        setEspecialidades(respuesta.data.content.specialities);
      });
  }, []);

  return (
    <>
      <style>
        {`
          .custom-modal-95 {
            max-width: 95% !important;
            width: 95% !important;
          }
        `}
      </style>
      <Modal
        dialogClassName="custom-modal-95"
        size="xl"
        show={show}
        onHide={onClose}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header
          closeButton
          closeVariant="white"
          style={{ backgroundColor: "rgb(135, 36, 52)", borderBottom: "none" }}
        >
          <Modal.Title style={{ color: "white", fontWeight: "bold", fontSize: "1.25rem", display: "flex", alignItems: "center" }}>
            <CalendarHeart size={26} className="me-2" color="white" />
            Solicitud para Agendar Cita
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ backgroundColor: "#fbfcfd", padding: "30px" }}>

          {/* Banner o mensaje introductorio */}
          <div className="text-center mb-4" style={{ backgroundColor: "rgba(0, 52, 121, 0.05)", borderRadius: "10px", padding: "25px 20px" }}>
            <img src="https://miseguro.somit.com/imagenes/no-proveedor.png" alt="Ayuda" style={{ width: "80%", maxWidth: "600px", objectFit: "contain", marginBottom: "20px" }} />
            <div>
              <h5 style={{ fontWeight: "bold", color: "rgb(0, 52, 121)", margin: 0, marginBottom: "8px" }}>¿No encuentras a tu proveedor?</h5>
              <p style={{ margin: 0, fontSize: "1rem", color: "#555", maxWidth: "800px", margin: "0 auto" }}>Completa este formulario con los detalles de tu cita ideal y nos pondremos en contacto contigo para asistirte.</p>
            </div>
          </div>

          <Row className="g-4">
            <Col lg={7}>
              {/* Card: Datos del médico y especialidad */}
              <Card className="shadow-sm mb-4" style={{ borderRadius: "12px", border: "1px solid #ebebeb" }}>
                <Card.Header style={{ backgroundColor: "#fff", borderBottom: "1px solid #f0f0f0", padding: "15px 20px" }}>
                  <h6 style={{ margin: 0, fontWeight: "bold", color: "rgb(0, 52, 121)", display: "flex", alignItems: "center" }}>
                    <Stethoscope size={18} className="me-2" /> Datos del Profesional
                  </h6>
                </Card.Header>
                <Card.Body style={{ padding: "20px" }}>
                  <div className="mb-3">
                    <Form.Label style={{ fontSize: "0.85rem", fontWeight: "600", color: "#6c757d" }}>NOMBRE DEL MÉDICO *</Form.Label>
                    <div className="d-flex align-items-center">
                      <User size={20} color="#adb5bd" className="position-absolute ms-3" />
                      <Input
                        type="text"
                        value={medico}
                        onChange={(e) => setMedico(e.target.value)}
                        placeholder="Ej. Dr. Juan Pérez"
                        maxLength={50}
                        style={{ borderRadius: "8px", paddingLeft: "40px", height: "45px", borderColor: "#ced4da" }}
                      />
                    </div>
                  </div>

                  <div>
                    <Form.Label style={{ fontSize: "0.85rem", fontWeight: "600", color: "#6c757d" }}>ESPECIALIDAD *</Form.Label>
                    <div className="d-flex align-items-center position-relative">
                      <Star size={20} color="#adb5bd" className="position-absolute ms-3" style={{ zIndex: 10 }} />
                      <div style={{ width: "100%" }}>
                        <Select
                          options={especialidades.map((e) => ({ value: e.id, label: e.name, ...e }))}
                          value={especialidad}
                          isClearable
                          onChange={(opcion) => setEspecialidad(opcion)}
                          placeholder="Buscar especialidad..."
                          styles={{
                            control: (base) => ({ ...base, borderRadius: "8px", minHeight: "45px", paddingLeft: "30px", borderColor: "#ced4da" })
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>

              {/* Card: Fecha y Hora */}
              <Card className="shadow-sm" style={{ borderRadius: "12px", border: "1px solid #ebebeb" }}>
                <Card.Header style={{ backgroundColor: "#fff", borderBottom: "1px solid #f0f0f0", padding: "15px 20px" }}>
                  <h6 style={{ margin: 0, fontWeight: "bold", color: "rgb(0, 52, 121)", display: "flex", alignItems: "center" }}>
                    <Calendar size={18} className="me-2" /> Programación Sugerida
                  </h6>
                </Card.Header>
                <Card.Body style={{ padding: "20px" }}>
                  <Row>
                    <Col md={6} className="mb-3 mb-md-0">
                      <Form.Label style={{ fontSize: "0.85rem", fontWeight: "600", color: "#6c757d" }}>FECHA DESEADA *</Form.Label>
                      <div className="position-relative">
                        <Calendar size={20} color="#adb5bd" className="position-absolute ms-3" style={{ top: "12px", zIndex: 10 }} />
                        <DatePicker
                          locale={es}
                          selected={fecha}
                          onChange={(date) => setFecha(date)}
                          dateFormat="yyyy-MM-dd"
                          className="form-control"
                          placeholderText="Seleccionar fecha"
                          style={{ borderRadius: "8px", height: "45px" }}
                          wrapperClassName="w-100"
                          customInput={<Input style={{ paddingLeft: "40px", borderRadius: "8px", height: "45px" }} />}
                        />
                      </div>
                    </Col>
                    <Col md={6}>
                      <Form.Label style={{ fontSize: "0.85rem", fontWeight: "600", color: "#6c757d" }}>HORA PREFERIDA *</Form.Label>
                      <div className="position-relative">
                        <Clock size={20} color="#adb5bd" className="position-absolute ms-3" style={{ top: "12px", zIndex: 10 }} />
                        <DatePicker
                          selected={hora}
                          onChange={(date) => setHora(date)}
                          showTimeSelect
                          showTimeSelectOnly
                          timeIntervals={15}
                          timeCaption="Hora"
                          dateFormat="HH:mm"
                          className="form-control"
                          placeholderText="Seleccionar hora"
                          wrapperClassName="w-100"
                          customInput={<Input style={{ paddingLeft: "40px", borderRadius: "8px", height: "45px" }} />}
                        />
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={5}>
              {/* Card: Tu Información */}
              <Card className="shadow-sm h-100" style={{ borderRadius: "12px", border: "1px solid #ebebeb", backgroundColor: "#fff" }}>
                <Card.Header style={{ backgroundColor: "rgba(135, 36, 52, 0.05)", borderBottom: "1px solid rgba(135, 36, 52, 0.1)", padding: "15px 20px" }}>
                  <h6 style={{ margin: 0, fontWeight: "bold", color: "rgb(135, 36, 52)", display: "flex", alignItems: "center" }}>
                    <User size={18} className="me-2" /> Tu Información de Contacto
                  </h6>
                </Card.Header>
                <Card.Body style={{ padding: "20px" }}>
                  <div className="mb-4">
                    <Form.Label style={{ fontSize: "0.85rem", fontWeight: "600", color: "#6c757d" }}>NOMBRE COMPLETO *</Form.Label>
                    <Input
                      type="text"
                      value={nombrePaciente}
                      onChange={(e) => setNombrePaciente(e.target.value)}
                      placeholder="Ingrese su nombre completo"
                      maxLength={50}
                      style={{ borderRadius: "8px", height: "45px", backgroundColor: "#f8f9fa", border: "1px solid #e0e0e0" }}
                    />
                  </div>

                  <div className="mb-4">
                    <Form.Label style={{ fontSize: "0.85rem", fontWeight: "600", color: "#6c757d" }}>TELÉFONO DE CONTACTO *</Form.Label>
                    <Input
                      type="tel"
                      value={telefono}
                      onChange={(e) => setTelefono(e.target.value)}
                      maxLength={8}
                      placeholder="Ej. 55555555"
                      style={{ borderRadius: "8px", height: "45px", backgroundColor: "#f8f9fa", border: "1px solid #e0e0e0" }}
                    />
                  </div>

                  <div style={{ backgroundColor: "#fff8f9", border: "1px dashed rgb(135, 36, 52)", padding: "15px", borderRadius: "8px", fontSize: "0.85rem", color: "#555" }}>
                    <strong>Aviso:</strong> Verifique que su número de teléfono sea correcto.
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer style={{ borderTop: "none", backgroundColor: "#fbfcfd", padding: "20px 30px" }}>
          <div className="w-100 d-flex justify-content-between align-items-center">
            <Button
              variant="light"
              onClick={handleRegresar}
              style={{ borderRadius: "50px", padding: "8px 24px", fontSize: "0.95rem", fontWeight: "600", color: "#6c757d", border: "1px solid #dee2e6", backgroundColor: "#fff" }}
            >
              CANCELAR
            </Button>
            <Button
              onClick={handleEnviar}
              style={{ borderRadius: "50px", padding: "8px 24px", fontSize: "0.95rem", fontWeight: "bold", backgroundColor: "rgb(0, 52, 121)", border: "none", boxShadow: "0 4px 10px rgba(0, 52, 121, 0.2)", letterSpacing: "0.5px", color: "#fff" }}
            >
              ENVIAR SOLICITUD <Send size={16} className="ms-2" />
            </Button>
          </div>
        </Modal.Footer>

        {loading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
              flexDirection: "column",
              borderRadius: "inherit"
            }}
          >
            <img
              src={loadingGif}
              alt="Cargando..."
              style={{ width: "100px" }}
            />
            <div className="mt-3 fw-bold" style={{ color: "rgb(0, 52, 121)" }}>Procesando solicitud...</div>
          </div>
        )}
      </Modal>
    </>
  );
};

export default RedProvFormularioModal;

